export default {
  heading: 'Odibee Sans, san-serif',
  body: 'Open Sans, san-serif',
  monospace: 'Menlo, monospace',
  display: 'san-serif',
  googleFonts: ['Open Sans:100,200,300,400,500,600,700,800,900', 'Odibee Sans']
  // customFamilies: [''],
  // customUrls: [''],
}
